import { usePermissoesOutletContext } from '@/pages/Permissoes.context'
import { permissoes } from '@/service/api'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

export default function ExcluirPerfilPermissao() {
    const { id } = useParams()
    const { data } = usePermissoesOutletContext()
    const item = data.find(i => i.id === Number(id))
    const { mutateAsync, isLoading } = permissoes.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!item) return null

    function handleSubmit() {
        mutateAsync(Number(id), {
            onSuccess: () => {
                toast.success('Perfil removido com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Permissões']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <>
                    Realmente deseja excluir o perfil de permissões {item.nome}?
                    Essa ação é irreversível.
                </>
            }
        />
    )
}
